import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "decta-3Ds__wrapper" }
const _hoisted_2 = {
  id: "dectaIframeModal",
  role: "dialog"
}
const _hoisted_3 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body iframe-container" }
const _hoisted_6 = {
  class: "embed-responsive embed-responsive-16by9",
  style: {"text-align":"center"}
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  class: "decta-3Ds__loading flex middle-xs center-xs"
}
const _hoisted_9 = { class: "black regular" }
const _hoisted_10 = { class: "regular black fs-bigger" }
const _hoisted_11 = { class: "black medium fs-bigger" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_13 = { class: "dot regular black fs-bigger" }
const _hoisted_14 = { class: "regular black fs-bigger" }

import { computed, ComputedRef, onBeforeUnmount, onMounted, ref } from 'vue';
  import { useStore } from 'vuex';
  import { useI18n } from 'vue-i18n';
  import { useRoute, useRouter } from 'vue-router';
  import { set as setCookie } from 'es-cookie';
  import { BaseUrls, NetworkHelper } from '@/api';
  import { isMobileWidth } from '@/plugins';
  import { getCleanedQuery, readQuery } from '@/utils/utils';
  import { Configurator, ThreeDsTypes, User } from '@/types';
  import { lazyComponent, lazyV2Views } from '@/router/routes';
  import NetworkListener from '@/views/components/NetworkListener.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  const MaintenancePage = lazyComponent('MaintenancePlaceholder');
  const AppOutdatedPlaceholder = lazyComponent('AppOutdatedPlaceholder');
  const AuthModalComponent = lazyComponent('Auth/AuthModalComponent');
  const GeniusModalComponent = lazyComponent('GeniusModalComponent');
  const CompletePaymentComponent = lazyComponent('CompletePaymentComponent');
  const ModalComponent = lazyComponent('ModalComponent');
  const BookingModalsComponent = lazyComponent(
    'BookingSteps/BookingModalsComponent',
  );
  const TestConfiguratorModalComponent = lazyComponent(
    'Configurator/TestConfiguratorModalComponent',
  );
  const WelcomeModal = lazyV2Views('features/WelcomeModal');

  const store = useStore();
  const route = useRoute();
  const router = useRouter();
  const { t, tm } = useI18n();

  const isMaintenanceInfoShown = ref<boolean>(false);

  const userV2: ComputedRef<User.UserV2 | null> = computed(
    () => store.state.user.userV2,
  );
  const isConfiguratorModalOpen: ComputedRef<boolean> = computed(
    () => store.state.support.isConfiguratorModalOpen,
  );
  const isRedirectModalShown: ComputedRef<boolean> = computed(
    () => store.state.car.isRedirectModalShown,
  );
  const threeDsState: ComputedRef<ThreeDsTypes.FrameState> = computed(
    () => store.state.booking.threeDSState,
  );

  onMounted(() => {
    const sessionId = readQuery('x-session-id');
    const userId = readQuery('x-user-id');
    const view = readQuery('view');
    const pricingMode = readQuery('pricing_mode');
    const modalDestination = readQuery('modal');
    const prtv = readQuery('prtv');
    const name = readQuery('name');

    if (pricingMode) {
      if (pricingMode === '1') {
        store.commit('user/toggleUserCategorySwitcher', true);
      }

      store.commit(
        'user/setUserCategory',
        pricingMode === '1'
          ? User.UserCategory.Category.Individual
          : User.UserCategory.Category.Business,
      );
    }

    if (modalDestination && !NetworkHelper.authed()) {
      if (modalDestination === 'auth') {
        setAuthDialogShown(true);
      }
      if (modalDestination === 'register') {
        setRegisterDialogShown(true);
      }
    }

    if (sessionId && userId) {
      localStorage.setItem(NetworkHelper.LEGACY_SESSION, sessionId);
      localStorage.setItem(NetworkHelper.LEGACY_USERID, userId);

      if (view) {
        localStorage.setItem('view', view);
      }

      store.commit('support/setAppView', true);
    }

    if (!!localStorage.getItem('view')) {
      store.commit('support/setAppView', true);
    }

    if (prtv) {
      setCookie('prtv', prtv + '', { expires: 365 });
    }

    if (name) {
      store.commit('support/toggleWelcomeDialog', { isShown: true, name });
    }

    checkAuth();

    onResize();
    addOnResizeListener();

    const testTool: Configurator.State = Configurator.builder();
    isMaintenanceInfoShown.value = testTool
      ? testTool.hostModule.showMaintenance
      : BaseUrls.isProd;

    if (testTool) {
      addCongiuratorHotkeyListener();
    }

    cleanQuery();
  });

  onBeforeUnmount(() => {
    removeCongiuratorHotkeyListener();
    removeOnResizeListener();
  });

  function setAuthDialogShown(show: boolean) {
    store.commit('user/setAuthDialogShown', show);
  }
  function setRegisterDialogShown(show: boolean) {
    store.commit('user/setRegisterDialogShown', show);
  }
  function toggleConfiguratorModal(show: boolean) {
    store.commit('support/toggleConfiguratorModal', show);
  }
  function closeRedirectModal() {
    store.commit('car/toggleRedirectModal', false);
  }
  function closeThreeDsIFrame() {
    store.commit('booking/setThreeDSState', {
      show: false,
      loading: false,
      source: null,
    });
  }

  async function checkAuth() {
    const _user = await store.dispatch('user/getUser');
    if (!_user && route.name === 'hotel') {
      setRegisterDialogShown(true);
    }
  }

  function onHotkeyCall(event) {
    if (event.ctrlKey && event.shiftKey && event.code === 'KeyU') {
      toggleConfiguratorModal(!isConfiguratorModalOpen.value);
    }
  }

  function addCongiuratorHotkeyListener() {
    window.addEventListener('keydown', onHotkeyCall, false);
  }

  function removeCongiuratorHotkeyListener() {
    window.removeEventListener('keydown', onHotkeyCall, false);
  }

  function onResize() {
    store.commit('support/setIsMobile', isMobileWidth());
  }

  function addOnResizeListener() {
    window.addEventListener('resize', onResize, false);
  }

  function removeOnResizeListener() {
    window.removeEventListener('resize', onResize, false);
  }

  function cleanQuery() {
    const query = getCleanedQuery([
      'currency',
      'lang',
      'modal',
      'pricing_mode',
    ]);

    router.replace({
      path: window.location.pathname,
      query,
    });
  }

return (_ctx: any,_cache: any) => {
  const _component_metainfo = _resolveComponent("metainfo")!
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_metainfo, null, {
      title: _withCtx(({ content }) => [
        _createTextVNode(_toDisplayString(content ?? `${_unref(t)('mainpage.title')} - FinalPrice`), 1 /* TEXT */)
      ]),
      ogtitle: _withCtx(({ content }) => [
        _createTextVNode(_toDisplayString(content ?? `${_unref(t)('mainpage.title')} - FinalPrice`), 1 /* TEXT */)
      ]),
      description: _withCtx(({ content }) => [
        _createTextVNode(_toDisplayString(content ?? `Wholesale and exclusive hotel prices worldwide`), 1 /* TEXT */)
      ]),
      ogimage: _withCtx(({ content }) => [
        _createTextVNode(_toDisplayString(content ??
          `https://rm-content.s3.amazonaws.com/5861a746ee966e0068bb7c35/upload-e38f8830-e631-11e7-923a-7527d5e38b7c.png`), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_unref(TestConfiguratorModalComponent), {
      state: _unref(isConfiguratorModalOpen),
      onSetState: _cache[0] || (_cache[0] = ($event: any) => (toggleConfiguratorModal($event)))
    }, null, 8 /* PROPS */, ["state"]),
    (isMaintenanceInfoShown.value)
      ? (_openBlock(), _createBlock(_unref(MaintenancePage), { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_RouterView),
          _createVNode(_unref(CompletePaymentComponent)),
          _createVNode(_unref(BookingModalsComponent)),
          _withDirectives(_createVNode(_unref(ModalComponent), {
            class: "decta-3Ds",
            type: "prompt",
            state: true,
            clickOutside: false,
            onModalClose: _cache[1] || (_cache[1] = ($event: any) => (closeThreeDsIFrame())),
            "modal-name": "decta",
            isLoading: _unref(threeDsState).loading,
            disallowClosing: _unref(threeDsState).loading
          }, {
            title: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_unref(threeDsState).loading
              ? _unref(t)('hotelpage.paymentProcess.loadingTitle')
              : _unref(t)('hotelpage.paymentProcess.title')), 1 /* TEXT */)
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("iframe", {
                            id: "3DsIframe",
                            sandbox: "allow-scripts allow-forms allow-same-origin",
                            style: {"border":"0"},
                            frameborder: "0",
                            marginheight: "0",
                            marginwidth: "0",
                            scrolling: "auto",
                            src: _unref(threeDsState).source
                          }, "\n                    ", 8 /* PROPS */, _hoisted_7)
                        ])
                      ])
                    ])
                  ])
                ]),
                (_unref(threeDsState).loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(t)('hotelpage.paymentProcess.content')), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["isLoading", "disallowClosing"]), [
            [_vShow, _unref(threeDsState).show]
          ])
        ], 64 /* STABLE_FRAGMENT */)),
    _createVNode(_unref(AuthModalComponent)),
    (_unref(userV2))
      ? (_openBlock(), _createBlock(_unref(GeniusModalComponent), {
          key: 2,
          isShown: _unref(isRedirectModalShown),
          title: _unref(t)('cars.rentalcarsRedirectModal.title'),
          link: `https://www.booking.com/cars/index.ru.html?aid=2185777&label=${_unref(userV2)?.userId}`,
          btnText: _unref(t)('cars.rentalcarsRedirectModal.btn'),
          onOnClose: _cache[2] || (_cache[2] = ($event: any) => (closeRedirectModal())),
          onOnSupplierLinkClick: _cache[3] || (_cache[3] = ($event: any) => (closeRedirectModal()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)('cars.rentalcarsRedirectModal.subtitle')), 1 /* TEXT */),
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_11, _toDisplayString(_unref(t)('cars.rentalcarsRedirectModal.listHeader')), 1 /* TEXT */),
              _hoisted_12,
              _createElementVNode("ul", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tm)('cars.rentalcarsRedirectModal.list'), (item, i) => {
                  return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(item), 1 /* TEXT */))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]),
            _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(t)('cars.rentalcarsRedirectModal.sublisttext')), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["isShown", "title", "link", "btnText"]))
      : _createCommentVNode("v-if", true),
    _createVNode(NetworkListener),
    _createVNode(_unref(AppOutdatedPlaceholder)),
    _createVNode(_unref(WelcomeModal))
  ]))
}
}

})